// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import reportConclusionEntity from './entities/report-conclusion.json';
import reportConclusionMenu from '../pages/report-conclusion/menu.json';
import reportConclusionFullForm from '../pages/report-conclusion/forms/full.json';
import reportConclusionContextForm from '../pages/report-conclusion/forms/context.json';
import reportConclusionMiniForm from '../pages/report-conclusion/forms/mini.json';
import reportConclusionLookupForm from '../pages/report-conclusion/forms/lookup.json';
import reportConclusionTableView from '../pages/report-conclusion/views/table.json';
import reportConclusionCardsView from '../pages/report-conclusion/views/cards.json';
import reportConclusionDashboardView from '../pages/report-conclusion/views/dashboard.json';

/** Тип запису «Висновок звіту» зі сторінками пакета: меню, форми та подання з pages/report-conclusion/. */
export const reportConclusionDefinition: IRecordTypeDefinition = {
  ...reportConclusionEntity,
  views: assembleViewSet({
      table: reportConclusionTableView,
      cards: reportConclusionCardsView,
      dashboard: reportConclusionDashboardView,
  }),
  form: reportConclusionFullForm,
  forms: { full: reportConclusionFullForm, context: reportConclusionContextForm, mini: reportConclusionMiniForm, lookup: reportConclusionLookupForm },
  menu: reportConclusionMenu,
} as IRecordTypeDefinition;
